'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// /home/readymade/apps/facelift_production/shared/~/react-dom/index.js
// module id = 108
// module chunks = 0 1